// get
export const FLAG_GETTING_REGIONS = 'FLAG_GETTING_REGIONS';
export const GET_REGIONS = 'GET_REGIONS';
export const CLEAR_REGIONS = 'CLEAR_REGIONS';